import styles from "./InfoBox.module.css";
import { TRootState } from "../store/create-store";
import { useSelector } from "react-redux";
import SectionTitle from "../components/SectionTitle";
import Icon from "../components/Icon";
import { selectRootState } from "../selectors";

const InfoBox = () => {
  const { errors } = useSelector(selectInfoBox);

  return errors?.length ? (
    <div className={styles.wrapper}>
      <SectionTitle>
        <Icon name="error" />
        Failed to load dataset
      </SectionTitle>

      <ul className={styles.errorList}>
        {errors.map((error, index) => (
          <li key={index} className={styles.error}>
            {error}
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

const selectInfoBox = (state: TRootState) => {
  return {
    errors: selectRootState(state).errors,
  };
};

export default InfoBox;
